import { css, type Interpolation, type Theme } from '@emotion/react'
import { SVGProps, memo } from 'react'

interface WhiteboardProps extends SVGProps<SVGSVGElement> {
    css?: Interpolation<Theme>
    filled?: boolean
}

// const Whiteboard = memo((props: WhiteboardProps) => {
//     const { css, filled, ...svgProps } = props
//     return (
//         <svg
//             style={{ width: '1.5rem', height: '1.5rem' }}
//             data-testid="IconButton__Whiteboard"
//             viewBox="-1 -2 24 24"
//             css={css}
//             {...svgProps}
//         >
//             <title>{'Whiteboard'}</title>
//             <path
//                 d="M20.134 1H1v14.032h4.847l-2.232 4.145 1.148.574 1.212-2.232h9.248l1.212 2.232 1.148-.574-2.232-4.145h4.783V1zm-5.613 15.307H6.613l.701-1.275h6.506l.701 1.275zm4.337-2.551H2.276V2.276h16.582v11.48z"
//                 style={{ fill: 'currentcolor' }}
//             />
//         </svg>
//     )
// })

const whiteboardStyles = css({
    width: '1.5rem',
    height: '1.5rem',
    fill: 'currentcolor',
})

const Whiteboard = memo((props: WhiteboardProps) => {
    const { css, filled, ...svgProps } = props
    return (
        <svg
            data-testid="IconButton__Whiteboard"
            css={[whiteboardStyles, css]}
            viewBox="0 0 24 24"
            {...svgProps}
        >
            {filled ? (
                <path d="M20 4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h4l-1.8 2.4 1.6 1.2 2.7-3.6h3l2.7 3.6 1.6-1.2L16 18h4c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM5 13h4v2H5v-2z" />
            ) : (
                <>
                    <path d="M20 3H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h4l-1.8 2.4 1.6 1.2 2.7-3.6h3l2.7 3.6 1.6-1.2L16 18h4c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 16V5h16l.001 11H4z" />
                    <path d="M6 12h4v2H6z" />
                </>
            )}
        </svg>
    )
})

export default Whiteboard
